import { useState, useEffect } from "react";
import { getDrivers } from "../services/drivers";

// Global cache keyed by params string
const driversCache = {};

export const useDrivers = ({ reload = false, params = {} } = {}) => {
  const key = JSON.stringify(params); // unique cache key for these params
  const [drivers, setDrivers] = useState(driversCache[key] || []);
  const [loading, setLoading] = useState(false);

  const fetchDrivers = async () => {
    setLoading(true);
    try {
      const [err, data] = await getDrivers(params);
      if (!err) {
        driversCache[key] = data || [];
        setDrivers(driversCache[key]);
      }
    } catch (e) {
      console.error("Error fetching drivers:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!driversCache[key] || reload) {
      fetchDrivers();
    } else {
      setDrivers(driversCache[key]);
    }
  }, [key, reload]);

  return { drivers, loading, refresh: fetchDrivers };
};
